import { gql } from "@apollo/client";

export const GET_BUYER_DATA = gql`
	query GroupActivity($params: UserQueryParams, $requestsParams2: RequestQueryParams) {
		user(params: $params) {
			groupOne {
				buyerProjects {
					id
					interestedInProject
					visitRequested
					locality
					processDetails {
						process
						stage
						status
					}
					project {
						id
					}
				}
				buyerUnits {
					id
					interestedInProject
					visitRequested
					processDetails {
						process
						stage
						status
					}
					unit {
						_id
					}
				}
				members {
					id
					identifier
					name
					designation
				}
				id
				identifier
				relationship
				name
				type
			}
		}
		requests(params: $requestsParams2) {
			groupActivity {
				projectVisitC2c {
					project {
						id
					}
				}
			}
		}
	}
`;
